import { render, staticRenderFns } from "./SingleProgram.vue?vue&type=template&id=18f77b34&"
import script from "./SingleProgram.vue?vue&type=script&lang=js&"
export * from "./SingleProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports